var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHu = function SvgHu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hu_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#436F4D",
    d: "M31 6H1v20h30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31 6H1v13.333h30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD2A3E",
    d: "M31 6H1v6.667h30z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    d: "M9.4 6.25h13.2c1.124 0 1.952 0 2.607.054.651.053 1.109.158 1.495.355a3.75 3.75 0 0 1 1.64 1.639c.196.386.301.844.354 1.495.054.655.054 1.483.054 2.607v7.2c0 1.124 0 1.952-.054 2.607-.053.651-.158 1.109-.355 1.495a3.75 3.75 0 0 1-1.639 1.64c-.386.196-.844.301-1.495.354-.655.054-1.483.054-2.607.054H9.4c-1.124 0-1.952 0-2.607-.054-.651-.053-1.109-.158-1.495-.355a3.75 3.75 0 0 1-1.64-1.639c-.196-.386-.301-.844-.354-1.495-.054-.655-.054-1.483-.054-2.607v-7.2c0-1.124 0-1.952.054-2.607.053-.651.158-1.109.355-1.495a3.75 3.75 0 0 1 1.639-1.64c.386-.196.844-.301 1.495-.354.655-.054 1.483-.054 2.607-.054Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hu_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  })))));
};
export default SvgHu;